import { AppResourcePage } from './app-resource-base';
import { branchSwitchOnResource } from './helpers/branch-switch';
import { cache } from '../cache-impl/cache-registry';
import { checkSuppliersIsOnline } from '../quotes/quote-creator';
import { createQuoteView, getQuoteContainer, getQuoteContainerManager, QuoteLock } from '../quotes/quote-ui-adapter';
import { customElement } from 'lit/decorators.js';
import { FranchiseeQuoteContainerManager } from '../quotes/data/franchisee-quote-manager';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { information } from '../../../webmodule-common/other/ui/modal-option';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { ResourceLocker } from '../common/resource-lock';
import { v6BootLoader } from '../../v6config/v6config';
import { getQuoteTitleStr } from '../../quotes/data/quote-helper-functions';
import { LangAppQuotePage } from '../../../localization/scripts/dealer-franchisee/pages/app-quote-lang';

@customElement('app-quote')
export class AppQuotePage extends AppResourcePage {
  qm?: FranchiseeQuoteContainerManager;

  async createModalEditor(id: string): NullPromise<ModalViewBase> {
    if (!(await v6BootLoader())) {
      await information(LangAppQuotePage.supplierOfflineMsg());
      this.forcedReadonly = true;
      this.forcedReadonlyMsg = LangAppQuotePage.supplierOffline();
    }

    const container = getQuoteContainer(id);
    if (isEmptyOrSpace(id)) id = container.quoteId;

    this.qm = getQuoteContainerManager(container, this.lock) as FranchiseeQuoteContainerManager;
    const qm = this.qm;
    if (!(await qm.needsQuote())) return null;

    if (!(await branchSwitchOnResource(qm.branchQuote.branchId, LangAppQuotePage.quoteGlossary()))) return null;
    if (!(await checkSuppliersIsOnline(this.qm.quote.supplierId))) {
      await information(LangAppQuotePage.supplierOfflineMsg());
      this.forcedReadonly = true;
      this.forcedReadonlyMsg = LangAppQuotePage.supplierOffline();
    }
    this.qm.forceLockout = this.forcedReadonly;

    return await createQuoteView(qm);
  }

  async redirectPath(): NullPromise<string> {
    return '/quotes';
  }

  meta() {
    return {
      title: () => LangAppQuotePage.quoteEditorTitle({ quoteTitle: getQuoteTitleStr(this.qm?.quote, undefined, true) }),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected async resourceRefreshing() {
    await super.resourceRefreshing();
    if (this.qm?.quote.id) {
      await cache().projectResourceLink.updateLocal(this.qm?.quote.id);
      await cache().quote.updateLocal(this.qm?.quote.id);
    }
  }

  protected createLock(id: string): ResourceLocker | undefined {
    return new QuoteLock(id, async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/quotes');
    });
  }
}
